// API service for notifications
import apiService from './apiService';

class NotificationApiService {
  // Get all notifications
  async getNotifications(params = {}) {
    try {
      const response = await apiService.get('/notifications', { params });
      return response;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }

  // Create a new notification
  async createNotification(notificationData) {
    try {
      const response = await apiService.post('/notifications', notificationData);
      return response.data;
    } catch (error) {
      console.error('Error creating notification:', error);
      throw error;
    }
  }

  // Get a specific notification
  async getNotification(id) {
    try {
      const response = await apiService.get(`/notifications/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching notification:', error);
      throw error;
    }
  }

  // Mark notification as read
  async markAsRead(id) {
    try {
      const response = await apiService.patch(`/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  // Mark all notifications as read
  async markAllAsRead(userId = null) {
    try {
      const params = userId ? { user_id: userId } : {};
      const response = await apiService.patch('/notifications/read-all', params);
      return response.data;
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }

  // Mark notification as approved
  async markAsApproved(id) {
    try {
      const response = await apiService.patch(`/notifications/${id}/approve`);
      return response.data;
    } catch (error) {
      console.error('Error marking notification as approved:', error);
      throw error;
    }
  }

  // Mark notification as rejected
  async markAsRejected(id) {
    try {
      const response = await apiService.patch(`/notifications/${id}/reject`);
      return response.data;
    } catch (error) {
      console.error('Error marking notification as rejected:', error);
      throw error;
    }
  }

  // Delete a notification
  async deleteNotification(id) {
    try {
      const response = await apiService.delete(`/notifications/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  }

  // Clear all notifications
  async clearAll(userId = null) {
    try {
      const params = userId ? { user_id: userId } : {};
      const response = await apiService.delete('/notifications', { params });
      return response.data;
    } catch (error) {
      console.error('Error clearing notifications:', error);
      throw error;
    }
  }

  // Get notification statistics
  async getStats(userId = null) {
    try {
      const params = userId ? { user_id: userId } : {};
      const response = await apiService.get('/notifications/stats', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching notification stats:', error);
      throw error;
    }
  }
}

// Create singleton instance
const notificationApiService = new NotificationApiService();

export default notificationApiService;
